import React from "react";
import PropTypes from "prop-types";
import "../../styles/customCheckbox.scss";

function CustomCheckbox({ id, checked, onChange }) {
  return (
    <div className="custom-checkbox-container">
      <input
        className="custom-checkbox-container-input"
        type="checkbox"
        checked={checked}
        id={`item-${id}`}
        onChange={
          onChange
        }
      />
    </div>
  );
}

CustomCheckbox.propTypes = {};

export default CustomCheckbox;
